import { render } from "./MediaflowSceneCanvas.vue?vue&type=template&id=32a1d03f&scoped=true"
import script from "./MediaflowSceneCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSceneCanvas.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowSceneCanvas.vue?vue&type=style&index=0&id=32a1d03f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a1d03f"],['__file',"src/components/Mediaflow/MediaflowSceneCanvas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32a1d03f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32a1d03f', __exports__)) {
    api.reload('32a1d03f', __exports__)
  }
  
  module.hot.accept("./MediaflowSceneCanvas.vue?vue&type=template&id=32a1d03f&scoped=true", () => {
    api.rerender('32a1d03f', render)
  })

}


export default __exports__